import { render, staticRenderFns } from "./SuratJalanTest.vue?vue&type=template&id=20a73494&scoped=true&"
import script from "./SuratJalanTest.vue?vue&type=script&lang=js&"
export * from "./SuratJalanTest.vue?vue&type=script&lang=js&"
import style0 from "./SuratJalanTest.vue?vue&type=style&index=0&id=20a73494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a73494",
  null
  
)

export default component.exports